import { render } from "./CustomFormControl.vue?vue&type=template&id=3b023050"
import script from "./CustomFormControl.vue?vue&type=script&lang=ts"
export * from "./CustomFormControl.vue?vue&type=script&lang=ts"
script.render = render

export default script